module.exports = __webpack_public_path__ + "static/media/comment-exclamation.cfe98113.svg";